<template>
  <div class="quill-content prose max-w-full dark:prose-invert prose-img:h-auto prose-img:max-w-full">
    <!-- Conteúdo salvo pelo Quill (classes ql-indent-* têm estilo global em tailwind.css) -->
    <div v-html="props.conteudo" class="ql-editor"></div>
  </div>
</template>

<script setup>
  import { defineProps } from 'vue';
  
  // Definindo as propriedades passadas para o componente
  const props = defineProps({
    conteudo: {
      type: String,
      required: true
    }
  });
  </script>
  
  
